import { ContractorDocument } from './types';

export const taxFormComplianceLabel = (documents: ContractorDocument[], requiredTypes: string[]) => {
  if (requiredTypes.length === 0) return 'No tax forms required';
  const currentStatusFor = (type: string) => {
    const current = documents.find((document) => document.type === type && document.status !== 'REPLACED');
    if (!current) return 'MISSING';
    if (current.status === 'APPROVED' && current.expiresAt && new Date(current.expiresAt).getTime() <= Date.now()) return 'EXPIRED';
    return current.status === 'PENDING' ? 'PENDING_REVIEW' : current.status;
  };
  const statuses = requiredTypes.map(currentStatusFor);
  if (statuses.every((status) => status === 'APPROVED')) return 'Booking ready';
  if (statuses.every((status) => ['APPROVED', 'PENDING_REVIEW'].includes(status))) return 'Bid ready · review required';
  if (statuses.some((status) => status === 'REJECTED' || status === 'EXPIRED')) return 'Action required';
  return 'Incomplete';
};
